import React from 'react'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeadCell, TableRow, Button } from "flowbite-react";
import { PencilSquareIcon, TagIcon, ListBulletIcon, TrashIcon, FolderPlusIcon } from '@heroicons/react/24/outline'
import Modals from '../../components/Modal'
import FormUser from './FormUser';
import RolesList from './RolesList';
import SolutionsList from '../solution/solutionList';
import LoadingSpinner from '../../components/LoadingSpinner';


const user = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const [modalTitle, setModalTitle] = useState("");
    const [userId, setUserId] = useState(null);
    const [users, setUsers] = useState([]);
    const [error, setError] = useState(null);
    const [isCreating, setIsCreating] = useState(false);
    const [rolAssing, setRolesAssing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [modalTo, setModalTo] = useState("");

    const openModal = (title,idUser,editMode) => {
        setModalTitle(title);
        setIsModalOpen(true);
        setUserId(idUser);
        setIsCreating(editMode);
        setModalTo(title)
        title=="Roles"?setRolesAssing(true):setRolesAssing(false);
    };
    const handleFormSubmit = async(data) => {
        
        let name = data.name == "";
        if(name){ alert("Ingrese el permiso"); return;}

        let email = data.email == "";
        if(email){ alert("Ingrese el email"); return;}

        let password = data.password == "";
        if(password){ alert("Ingrese el password"); return;}

        let status = data.status == "";
        if(status){ alert("Seleccione el estado"); return;}

        setIsLoading(true);
        try {
            const response = await axios.post(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/user/create`,
                data,
                {
                    withCredentials: true,
                }
            );
            setUsers([...users, response.data.new_user]);
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        }

        closeModal(); 
    };

    const handleFormUpdate = async(data) => {
        setIsLoading(true);
        try {
            const response2 = await axios.put(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/user/${userId}/update`,
                data,
                {
                    withCredentials: true,
                }
            );

            console.log("userId",userId);
            setUsers(
                users.map((user) =>
                    user.id === userId ? { ...users, ...response2.data.usuario } : user
                )
            ); 
        } catch (error) {
            
        } finally{
            setIsLoading(false);
        } 

        closeModal(); 
    }

    const handleRemove = async (id) => {
        const confirma = confirm('Confirma la eliminación del usuario?');
        if (!confirma) return;
        setIsLoading(true);
        try{
            const response = await axios.delete(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/user/${id}/delete`,
                {
                    withCredentials: true,
                }
            );
            if(response.data.status){
              alert("Usuario eliminado correctamente");
            }else{
              alert("Problema al eliminar el usuario");
            }
            setUsers(users.filter((user) => user.id !== id));
           
        }catch(error){
            
        } finally{
            setIsLoading(false);
        } 
    }

    const getUsers = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get( 
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/users`,
                {
                    withCredentials: true,
                }
            );

            if (response.statusText !== "OK") {
                throw new Error(response.message || 'Error en la obtención de datos');
            }

            setUsers(response.data);
        } catch (error) {
            setError(error.message);
        } finally{
            setIsLoading(false);
        } 
    }

    const closeModal = () => {
        setIsModalOpen(false);
        getUsers(); // Refresca los usuarios después de cerrar la modal
    };



    useEffect(()=>{
        getUsers();
    },[]);

    return (
        <>
            {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
            <div className="p-2 mt-4 flex justify-between">
                <h1 className="text-xl mb-2 px-3 flex-col">Usuarios</h1>
                <div className="flex justify-end">
                    <Button className="text-gray-600" onClick={()=>openModal("Usuarios",null,true)} color='gray'>Crear</Button>
                </div>
                {error && <div className="text-red-500">{error}</div>}
            </div>
            <div className="overflow-x-auto">
                <Table>
                    <TableHead>
                        <TableHeadCell className="text-left">Nombre</TableHeadCell>
                        <TableHeadCell className="text-left">Email</TableHeadCell>
                        <TableHeadCell className="text-left">Estado</TableHeadCell>
                        <TableHeadCell className="text-left">Roles</TableHeadCell>
                        <TableHeadCell>
                            <span className="srOnly">Acción</span>
                        </TableHeadCell>
                    </TableHead>
                    <TableBody className="divide-y">
                        {users.map((user) => (
                            <TableRow key={user.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                <TableCell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                    {user.name}
                                </TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{(parseInt(user.status)===1)?'Activo':'Inactivo'}</TableCell>
                                
                                <TableCell>
                                    <ul className="list-disc pl-4">
                                        {
                                            user.Roles?.map((rol, index) => (
                                                <li key={index}>{rol.name}</li>
                                            ))
                                        }
                                    </ul>
                                </TableCell>                                
                                <TableCell className="inline-flex">
                                    
                                    <a href="#" onClick={()=>openModal("Solutions",user.id, false)}>
                                        <FolderPlusIcon className="w-5 text-blue-500 mr-3" title="Vincular Solución"/>
                                    </a>
                                    <a href="#" onClick={()=>openModal("Roles",user.id, false)}>
                                        <TagIcon className="w-5 text-blue-500 mr-3" title="Vincular Rol"/>
                                    </a>
                                    <a href="#" onClick={()=>openModal("Usuarios",user.id, false)}>
                                        <PencilSquareIcon className="w-5 text-blue-500 mr-3" title="Editar usuario"/>
                                    </a>
                                    <a href="#" onClick={()=>handleRemove(user.id)}>
                                        <TrashIcon className="w-5 text-blue-500 mr-3" title="Eliminar usuario"/>
                                    </a>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>

            <Modals isOpen={isModalOpen} onClose={closeModal} title={modalTitle} modalSize={"md"}>
                

                { modalTo == "Usuarios" && <FormUser onSubmit={isCreating ? handleFormSubmit : handleFormUpdate} onClose={closeModal} userId={userId} /> }
                { modalTo == "Roles" && <RolesList onClose={closeModal} userId={userId} users={users} setUsers/> }
                { modalTo == "Solutions" && <SolutionsList onClose={closeModal} userId={userId} users={users} setUsers/> }


            </Modals>
        </>
  )
}

export default user
